import React, {useContext} from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import SupplierContext from "../../../../contexts/SupplierContext";
import UIService from "../../../../services/UIService";
import IPackingListViewOptions from "../../../../models/IPackingListViewOptions";
import moment from "moment-timezone";
import IPacking_List from "../../../../models/IPacking_List";
import IOrder from "../../../../models/IOrder";

type Props = {
    packingList: IPacking_List;
    view: IPackingListViewOptions;
    pageSize: "STANDARD" | "MINIMAL";
    firstOrder: IOrder;
    orders: IOrder[];
    totalOrders: number;
    getCompiledData: () => { orderNumsArr: string[]; poNumsArr: string[]; notes: string; shipping_instructions: string; orderDescription: string; },
    getOrderDate: () => string,
    getDate: (orderModel: IOrder, property: "confirmed_date" | "estimated_shipping_at" | "created_at" | "submit_date") => string,
};

export const PackingListDetailDetailRow = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    let tableClass = "table-dark";

    if (UIService.isMainViewLight()) {
        tableClass = "";
    }

    const { shipping_instructions, notes, poNumsArr, orderNumsArr, orderDescription } = props.getCompiledData();

    const orderDate = props.getOrderDate();
    const estShipDate = props.orders.length > 2 ? "Mixed" : props.getDate(props.firstOrder, "estimated_shipping_at");
    const cancelDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.cancel_date).format("MM/DD/YYYY");
    const shippingDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.ship_date).format("MM/DD/YYYY");
    const doNotShipBeforeDate = props.orders.length > 2 ? "Mixed" : moment(props.firstOrder.do_not_ship_before_date).format("MM/DD/YYYY");

    const orderNums = orderNumsArr.join(", ");
    const poNums = poNumsArr.join(",");

    return <div className={"PackingListDetailDetailRow"}>
        {props.pageSize === "STANDARD" ? (
            <div className={"table-responsive"}>
                <table className={"table table-bordered " + tableClass}>
                    <tbody>
                    <tr>
                        <th>
                            <OwLabel title={"order_date"} className={"mb-0"} />
                        </th>
                        {supplierModel?.shipping_lead_time ? (
                            <th>
                                <OwLabel title={"est_ship_date"} className={"mb-0"} />
                            </th>
                        ) : null}
                        <th>
                            <OwLabel title={"order_no"} className={"mb-0"} />
                        </th>
                        <th>
                            <OwLabel title={"po_no"} className={"mb-0"} />
                        </th>
                        <th>
                            <OwLabel title={"notes"} className={"mb-0"} />
                        </th>
                        {shipping_instructions.length ? (
                            <th>
                                <OwLabel title={"shipping_instructions"} className={"mb-0"} />
                            </th>
                        ) : null}
                        {props.view.showOrderDescription ? (
                            <th>
                                <OwLabel title={"description"} />
                            </th>
                        ) : null}
                        {props.view.showOrderUser ? (
                            <th>
                                <OwLabel title={"user"} />
                            </th>
                        ) : null}
                    </tr>
                    <tr>
                        <td>{orderDate}</td>
                        {supplierModel?.shipping_lead_time ? <td>{estShipDate}</td> : null}
                        <td>{orderNums}</td>
                        <td>{poNums}</td>
                        <td>{notes}</td>
                        {shipping_instructions.length ? <td>{shipping_instructions}</td> : null}
                        {props.view.showOrderDescription ? <td>{orderDescription}</td> : null}
                        {props.view.showOrderUser ? <td>{props.firstOrder.User?.name}</td> : null}
                    </tr>
                    </tbody>
                </table>
            </div>
        ) : null}
    </div>;
};
